import React from 'react';
import { Cpu, MessageSquare, Shield, Rocket, RefreshCw } from 'lucide-react';

const EngineFeatures = () => {
  const features = [
    {
      icon: Cpu,
      title: 'AI-Crafted Training Programs',
      tagline: 'Navigator AI transforms your existing materials into structured, enterprise-grade Training.',
      bullets: [
        'SOPs, PDFs, presentations, and documentation become organized Training paths',
        'Training is consistent across every team and location',
        'Content reflects your standards, language, and expectations'
      ]
    },
    {
      icon: MessageSquare,
      title: 'Continuous Feedback & Skill Development',
      tagline: 'Training evolves as performance improves.',
      bullets: [
        'Real-time feedback connected to role-play and execution',
        'Skill progression tracked over time',
        'Clear insight for managers and leaders'
      ]
    },
    {
      icon: Shield,
      title: 'Enterprise Governance & Visibility',
      tagline: 'Designed for scale without friction.',
      bullets: [
        'Assign, manage, and track Training centrally',
        'Maintain consistent delivery across departments',
        'Ensure completion, visibility, and accountability'
      ]
    },
    {
      icon: Rocket,
      title: 'Built to Scale With the Business',
      tagline: 'Traain Engine supports growth without added operational burden.',
      bullets: [
        'Deliver Training to hundreds or thousands seamlessly',
        'Reduce onboarding time and manual coordination',
        'Maintain alignment across distributed teams'
      ]
    },
    {
      icon: RefreshCw,
      title: 'Seamless LMS Migration',
      tagline: 'Navigator AI makes it easy to move from a static LMS to Traain\'s dynamic training platform.',
      bullets: [
        'Existing training is migrated, converted, and enhanced—not lost',
        'Legacy courses become interactive, AI-driven learning paths',
        'Teams transition quickly without disruption or downtime'
      ]
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            How Traain Engine <span className="text-cyan-400">Works</span>
          </h2>
        </div>

        <div className="space-y-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-8 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-2xl hover:border-cyan-500/50 transition-all duration-300"
            >
              <div className="flex items-start gap-6 mb-6">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-7 h-7 text-cyan-400" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">{feature.title}</h3>
                  <p className="text-gray-400">{feature.tagline}</p>
                </div>
              </div>
              
              <div className="space-y-3 ml-20">
                {feature.bullets.map((bullet, bulletIndex) => (
                  <div key={bulletIndex} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                    <span className="text-gray-300">{bullet}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngineFeatures;
